import { useCallback, useEffect } from 'react';
import type { FieldValues, UseFormSetValue } from 'react-hook-form';

const SESSION_KEY = 'remember_marketo_form_email';

export const useRememberMarketoFormEmail = ({
  enabled = false,
  setValue,
  field,
}: {
  setValue: UseFormSetValue<FieldValues>;
  field: string;
  enabled?: boolean;
}) => {
  useEffect(() => {
    if (typeof window === 'undefined' || !enabled) {
      return;
    }

    try {
      const stored = window.sessionStorage.getItem(SESSION_KEY);
      if (stored) {
        setValue(field, stored);
      }
    } catch {}
  }, [enabled, setValue, field]);

  const persistEmail = useCallback(
    (email?: string) => {
      if (typeof window === 'undefined' || !enabled || !email) {
        return;
      }

      try {
        window.sessionStorage.setItem(SESSION_KEY, email);
      } catch {}
    },
    [enabled],
  );

  return { persistEmail };
};
